import React, {useCallback} from 'react';

import {Group} from '@pb/kit-component-group';
import {RadioButton, RadioButtons} from '@pb/kit-component-radio-button';

import {PB_HEADERS} from '../../constants';

import type {CrmIdType} from 'src/openapi/admin/models/CrmIdType';

type Props = {
    selectedCRMType: CrmIdType,
    setSelectedCRMType: (crmType: CrmIdType) => void,
};

export const SelectCrmType = (props: Props) => {
    const {selectedCRMType, setSelectedCRMType} = props;

    const onSelectCRMType = useCallback((value: CrmIdType) => {
        setSelectedCRMType(value);
    }, [setSelectedCRMType]);

    return (
        <Group direction="v" alignItems="start">
            Select witch CRM type you want to update
            <RadioButtons
                name="selected CRM Type"
                value={selectedCRMType}
                onChange={onSelectCRMType}>
                {Object.keys(PB_HEADERS).map(header => (
                    <RadioButton key={header} value={header} label={PB_HEADERS[header] || ''}/>
                ))}
            </RadioButtons>
        </Group>
    );
};
